module.exports = __webpack_public_path__ + "static/media/A1.3863f15a.jpg";